// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__2gVgu","selects":"Documents_selects__Jh_sV"};